import React, { FC, useCallback, useState } from 'react';

import { getClassNames } from './ShowWhenContainsFocus.styles';

/**
 * `ShowWhenContainsFocus` hides its content from sight. When it's focused via keyboard
 * tabbing it will make its content visible, positioning itself absolutely above the page at
 * the top left of the nearest non-static container element. Its primary use case is to
 * display a "Skip to main content" link as the first focusable element on the page.
 */
const ShowWhenContainsFocus: FC = ({ children }) => {
  const [containsFocus, setContainsFocus] = useState(false);

  const classNames = getClassNames();
  const className = containsFocus ? classNames.focused : classNames.root;

  const onFocus = useCallback(() => {
    setContainsFocus(true);
  }, []);

  const onBlur = useCallback(() => {
    setContainsFocus(false);
  }, []);

  return (
    <div className={className} onFocus={onFocus} onBlur={onBlur}>
      {children}
    </div>
  );
};

export default ShowWhenContainsFocus;
